import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Map } from 'immutable';
import { login } from '../../actions/session';
import LoginForm from './LoginForm';

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (username, password) => {
    dispatch(login(username, password));
  },
});

const Login = (props) => {
  const sessionStateMessage = props.session.get('sessionStateMessage') && props.session.get('sessionStateMessage').message;
  const sessionState = props.session.get('sessionState');

  return (
    <div className="login">
      <LoginForm
        onSubmit={(user, pass) => props.onSubmit(user, pass)}
        sessionStateMessage={sessionStateMessage || ''}
        isLoading={sessionState === 'LOGIN_REQUEST'}
      />
      <div className="login-copy">
        <h3 className="login-copy__header">Digital Media Warehouse</h3>
        <p className="login-copy__text">
          For managing all types of digital content including images, video, audio and documents.
          We combine a full digital asset management system with strong workflow and content
          distribution functions to provide a platform
          that can solve your digital media management requirements.
        </p>
      </div>
    </div>
  );
};

Login.propTypes = {
  onSubmit: PropTypes.func,
  session: PropTypes.instanceOf(Map),
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Login));



// WEBPACK FOOTER //
// ./src/js/components/Login/index.jsx